









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/activity/edit/EditPage.vue'
import { getDefaultAloActivity, AloActivity } from '@/models/alo/AloActivity'
import ReadBasePage from '@/components/shared/ReadBasePage.vue'

@Component({
  name: 'ReadPage',    
   props: {
    activity:{      
      default:getDefaultAloActivity()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ReadBasePage}
})
export default class ReadPage extends Vue {
  private activity!:AloActivity
  private loading!:boolean

  get codeYoutube(){
    return  this.activity.configActivity.youtube
  }

  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.activity) }
}
